import React from 'react';
import styled from 'styled-components';

interface ImageDropLayerProps {
  isVisible: boolean;
  title: string;
  description?: string;
}

const ImageDropLayer: React.FC<ImageDropLayerProps> = ({
  isVisible,
  title,
  description,
}) => {
  if (!isVisible) return null;

  return (
    <LayerContainer>
      <DropZone>
        <DropText>{title}</DropText>
        {description && <LimitText>{description}</LimitText>}
      </DropZone>
    </LayerContainer>
  );
};

const LayerContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
  pointer-events: none;
`;

const DropZone = styled.div`
  padding: 20px 36px;
  border: 1px dashed ${({ theme }) => theme.colors.color_Gray_05};
  text-align: left;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.02);
    }
  }
`;

const DropText = styled.div`
  margin-bottom: 6px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_02_1};
`;

const LimitText = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_03_1};
`;

export default ImageDropLayer;
